import { TextInputField } from '@1debit/chimekit';
import type { FormEventHandler } from 'react';
import Button from 'components/shared/Buttons/BaseButton';
import { BUDGET_SECTIONS, INCOME_FIELD } from './constants';
import type { BudgetSectionKey } from './types';

const sectionHintId = (key: BudgetSectionKey) => `budget-calculator-${key}-hint`;

export const BudgetCalculatorForm = () => {
  const handleSubmit: FormEventHandler<HTMLFormElement> = event => {
    event.preventDefault();
  };

  return (
    <form aria-label="Budget calculator" className="flex flex-col gap-8" onSubmit={handleSubmit}>
      <TextInputField label={INCOME_FIELD.label} hint={INCOME_FIELD.hint} inputMode="decimal" />

      {BUDGET_SECTIONS.map(section => (
        <fieldset key={section.key} aria-describedby={sectionHintId(section.key)}>
          <legend className="text-heading-sm">{section.heading}</legend>
          <p id={sectionHintId(section.key)} className="mt-2 text-legal text-content-secondary">
            {section.hint}
          </p>

          <div className="mt-6 grid gap-6 sm:grid-cols-2">
            {section.fields.map(field => (
              <TextInputField key={field.label} label={field.label} hint={field.hint} inputMode="decimal" />
            ))}
          </div>
        </fieldset>
      ))}

      <div className="flex flex-col gap-4 sm:flex-row">
        <Button type="submit">Calculate</Button>
        <Button type="button" variant="outline">
          Reset
        </Button>
      </div>
    </form>
  );
};
